import React from 'react';
import Navigation from '../components/Navigation';
import AskQuestion from '../components/AskQuestion';

function ProductPage() {
  return (
    <div>
      <Navigation hideLogin={true} />
      <AskQuestion />
    </div>
  );
}

export default ProductPage; 